<template>
    <billing-layout>
      
        <div class="container-fluid">
            <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header" style="padding-left: 0;">
                        <div class="row">
                          <div class="col-md-6">
                               <router-link :to="{name : 'EstimatesNew'}" class="btn btn-success"><i class="fas fa-plus"></i> Add Estimate</router-link>
      <!--   <div style="display:flex;">
            <div >Pending <span class="badge badge-secondary" style="margin-right:4px;"> <b>{{Pending.length}}</b></span></div>
            <div>Accepted <span class="badge badge-success" style="margin-right:4px;"> <b>{{Accepted.length}}</b></span></div>
            <div>Rejected <span class="badge badge-primary" style="margin-right:4px;"> <b>{{Rejected.length}}</b></span></div>
            <div>Void <span class="badge badge-danger"> <b>{{Void.length}}</b></span></div>
        </div> -->
                            </div>
                            <div class="col-md-6">
                             <div class="row">
                                 <div class="col-md-8">
                                    <input type="text" class="form-control" placeholder="Search" v-model="inputFilter" v-on:keyup="searchFilter">
                                 </div>
                                 <div class="col-md-2">
                                    <div class="basic_dropdown" v-click-outside="hideBtnstatus">
                                      <button class="btn-status"  @click="btnstatus()">Status <i class="fas fa-caret-down"></i></button>
                                      <ul class="reset dropdStatus" v-if="statusdropd">
                                        <li>
                                          <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" id="check12" @click="checkAll()" v-model="isCheckAll">
                                            <label class="custom-control-label" for="check12"><b>All</b></label>
                                          </div>
                                        </li>
                                        <li v-for="(item,index) in statusdata" :key="index">
                                          <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" :id="index" v-bind:value="item.value" v-model="statuslist" @change="searchFilter">
                                            <label class="custom-control-label" :for="index">{{item.name}}</label>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                 </div>
                                 <!-- <div class="col-md-2">
                                     <select v-model="paginador" class="form-control paginacion" @change="searchFilterPaginador">
                                      <option value="0">Display</option>
                                      <option value="200">200</option>
                                      <option value="300">300</option>
                                      <option value="500">500</option>
                                    </select>
                                 </div> -->
                             </div>
                            </div>
                        </div>
                    </div>
                <div class="row">
                <div class="col-md-12">
                <Loader v-if="isLoading"></Loader>
<div class="contenedor-estimate" v-else>
<table class="table table-striped table-bordered table-hover" v-if="EstimatesList.length > 0">
  <thead>
    <tr>
      <th scope="col">Est #</th>
      <th scope="col">Date</th>
      <th scope="col">Customer</th>
      <th scope="col">Name</th>
      <th scope="col" style="text-align:right">Total</th>
      <th scope="col" style="text-align:center">Status</th>
      <th scope="col" style="text-align:center">Email</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="item in EstimatesList" :key="item.id">
      <th scope="row">{{item.numdoc}} <NotesAdmin type='Estimate' :id="item.id" sTxt="display:none;" :btnNotes="item.notes" style="float:right;"/></th>
      <td>{{item.date_create}} </td>
      <td>{{item.firstname}} {{item.lastname}} <br><span style="color:#a9a9a9">{{item.bussinesname}}</span></td>
      <td>{{item.estimate_optional}}</td>
      <td style="text-align:right">${{item.total | formatMoney}}</td>
      <td style="text-align:center">
          <span v-if="item.status == 1" class="badge badge-secondary" style="background-color:#f89406">Pending</span>
          <span v-if="item.status == 2" class="badge badge-success">Accepted</span>
          <span v-if="item.status == 3" class="badge badge-primary">Rejected</span>
          <span v-if="item.status == 4" class="badge badge-danger" style="background-color:#f70d0d">Void</span>
      </td>
      <td style="text-align:center"><button @click="actionEmail(item.id,item.email,item.numdoc)" style="border:0;background: transparent;cursor:pointer;font-size:13px;">{{item.email_send}} <i class="fas fa-envelope" style="color:#f89406; font-size:18px;"></i></button></td>
      <td style="width:85px">
          <span class="cdropdown">
            <button>Actions</button>
            <label>
                <input type="checkbox">
                <ul>
                    <li @click="actionPdf(item.id)"><button><i class="fas fa-file-pdf"></i> Open PDF</button></li>
                    <li @click="actionPDFforEnvelope(item.id)"><button><i class="fas fa-file-pdf"></i> Open PDF for Envelope</button></li>
                    <li @click="actionPrint(item.id)"><button><i class="fas fa-print"></i> ePrint</button> </li>                    
                    <li  @click="actionDuplicate(item.id)" v-if="item.status != 4"><button><i class="fas fa-copy"></i> Duplicate</button> </li>
                    <li @click="convertToInvoice(item.id)" v-if="item.status == 2"><button><i class="far fa-file-alt"></i> Convert To Invoice</button> </li>
                    <li @click="actionEdit(item.id)" v-if="item.status != 4"><button><i class="fas fa-edit"></i> Edit</button></li>
                    <li @click="actionVoid(item.id)" v-if="item.status != 4"><button><i class="fas fa-trash-alt"></i> Void</button></li>
                    <li @click="MetDeleteEstimate(item.id)" v-if="item.status != 4"><button><i class="fas fa-times"></i> Delete</button> </li>
                </ul>
            </label>
        </span>
      </td>
    </tr>
  
  </tbody>
</table>
<div class="text-center d-block w-100 p20" v-else-if="EstimatesList.length==0 && isFilter==true">
  
    <div class="text-center" style="padding:30px;">No record</div>
</div>
<div class="text-center d-block w-100 p20" v-else>
  <div class="text-center" style="padding:30px;"> <span style="padding-bottom:30px">Its time to create your first Estimate! </span><br>
  <router-link :to="{name : 'EstimatesNew'}" class="btn btn-success " style="margin-top:7px">Create New Estimate</router-link>
  </div>
</div>
    </div>            
                    </div>


                    </div>
                </div>
              </div>
            </div>
        </div>
 <modal name="modal-setting" height="auto" @before-close="ClosedModal">
    <div class="card">
    <component :is="SettingBox" :items="DataMailEstimate"></component>
    </div>
</modal>
<notifications group="noti" position="top center">
</notifications>
    </billing-layout>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/shared/Loader'
import BillingLayout from '@/Layouts/Billing/BillingLayout'
import Taxes from '@/components/billing/setting/Taxes.vue';
import Terms from '@/components/billing/setting/Terms.vue';
import modalEmail from '@/components/billing/modalEmail'
import EventBus from '@/eventBus'
import NotesAdmin from '@/components/billing/NotesAdmin.vue';
import ClickOutside from 'vue-click-outside'
export default {
     name:'Estimates',
    components:{
            Loader,
            BillingLayout,
            Terms,
            Taxes,
            modalEmail,
            NotesAdmin

    },
    data() {
        return{
            isLoading : false,
            showModal: false,
            SettingBox : '',
            EstimatesList : [],
             DataMailEstimate : {
                isLoading : false,
                idinv : null,
                IDitem : null, // numdoc
                email : null,
                EmailCheck : false,
                view : 'estimate',
            },
            emailsE : [],
          inputFilter: '',
          OldEstimatesList: [],
          invStatus:0,
          isFilter: false,          
           isCheckAll: true,
           statusdata: [
             {'value' : '1','name' : 'Pending'},
             {'value' : '2','name' : 'Accepted'},
             {'value' : '3','name' : 'Rejected'},
             {'value' : '4','name' : 'Void'}
           ],
           statuslist: [1,2,3,4],
           statusdropd : false,
           paginador: 0,
        } 
    },
    created(){
      this.getEstimates();
    },
    mounted(){
    },    
    directives: {
      ClickOutside
    },
    methods:{
      abrirCanalEventBus(){
          let vm = this;
          EventBus.$on('estimate-email',(item)=>{
            this.emailsE =item; 
            vm.sendMailEstimate(item);
          }); 
        },

        btnstatus(){
         this.statusdropd = !this.statusdropd;
        },
        hideBtnstatus(){
          this.statusdropd = false;
        },
        checkAll: function(){

          this.isCheckAll = !this.isCheckAll;
          this.statuslist = [];
          if(this.isCheckAll){
            for (var key in this.statusdata) {
              this.statuslist.push(this.statusdata[key].value);
            }
            this.searchFilter();
          }
        },
        updateCheckall: function(){
            if(this.statuslist.length == this.statusdata.length){
              this.isCheckAll = true;
            }else{
              this.isCheckAll = false;
            }
        },
        searchFilter(){
          if(this.inputFilter.length > 1 || this.statuslist.length > 0)
          {
            this.isLoading = true;
            window.billing.post('filterestimate', 
              {
                user_id: window.localuserdata, 
                filter:this.inputFilter,
                status: this.statuslist,
                pag: this.paginador
              }
            ).then((response) => {
                  //console.log('filter ',response.data.result);
                  let listFilter = response.data.result;
                  let e = listFilter;
                    for (var i = 0; i < e.length; i++) {
                      let date_create= (new Date(e[i].date_create)+'' ).slice(4,15);
                      let date_create_new= date_create.split(' ');
                      listFilter[i].date_create=date_create_new[0]+' '+date_create_new[1]+', '+date_create_new[2];
                    }  
                  this.EstimatesList=listFilter
                  this.isFilter= true;
                  this.isLoading = false;
             }).catch((error) => {
                this.isLoading = false;
                console.log(error);
            });
          }
          else
          {
            this.EstimatesList=this.OldEstimatesList;
            this.isLoading = false;
            this.isFilter= false;
          }
        },
        searchFilterPaginador(){          
          if(this.paginador > 0)
          {
            this.searchFilter();
          }
          else
          {
            this.EstimatesList=this.OldEstimatesList;
            this.isLoading = false;
            this.isFilter= false;
          }
        },
        actionPdf(id){
            window.open(urlbase + "api/v2/estimate/pdf/" + id , "_blank");
        },
        actionPDFforEnvelope(id){
          window.open(urlbase + "api/v2/estimateenvelopes/pdf/" + id , "_blank");
        },
        actionEdit(id){
            this.$router.push({name:'EstimatesDet', params:{idest:id}});
        },
        ClosedModal(){
            this.SettingBox =''
        },
        getEstimates() {
              this.isLoading = true
            window.billing.get('estimates/' + window.localuserdata)
                .then((response) => {
                     //console.log('estimates list');
                    this.EstimatesList = response.data.result;
                    let e = this.EstimatesList;
                    for (var i = 0; i < e.length; i++) {
                      let date_create= (new Date(e[i].date_create)+'' ).slice(4,15);
                      let date_create_new= date_create.split(' ');
                      this.EstimatesList[i].date_create=date_create_new[0]+' '+date_create_new[1]+', '+date_create_new[2];
                    }

                  this.OldEstimatesList=this.EstimatesList;
           //console.log(this.EstimatesList);
					this.isLoading = false;
                }).catch((error) => console.log(error));
        },
        actionEmail(id,email,numdoc){
          this.$modal.show('modal-setting');
          this.SettingBox = 'modalEmail';
          this.DataMailEstimate.idinv = id;
          this.DataMailEstimate.IDitem = numdoc;
          this.DataMailEstimate.email = email;
          this.abrirCanalEventBus();
        },

        sendMailEstimate(item){
          if(item.DataItem.send==1){
            item.DataItem.send=0;
            this.$modal.hide('modal-setting');
            this.SettingBox = '';
            this.getEstimates();
            this.$notify({
              group: 'noti',
              title: 'Success',
              type: 'success',
              text: 'Send Mail!'
            });
            EventBus.$off('estimate-email');
          } 
        }, 
        actionPrint(idest){
          this.isLoading = true;
          window.billing.post('eprintest/' + idest,{
            user_id : window.localuserdata,
            eprint: 1
          }).then((response) => {
            console.log(response.data);
            this.isLoading = false;
            if(response.data.status){
              this.$notify({
                group: 'noti',
                title: 'Send Mail!',
                type: 'success',
                text: 'Send Successful',
              });
            }else{
              this.$notify({
                group: 'noti',
                title: 'Send Mail!',
                type: 'error',
                text: 'Send error',
              });
            }
          }).catch((error) => {
            console.log(error);
            this.isLoading = false;
            this.$notify({
              group: 'noti',
              title: 'Send Mail!',
              type: 'error',
              text: 'Send error',
            });
          });         
        },
        MetDeleteEstimate(idest){
          this.isLoading = true
          this.$swal({
            title: "Delete this Estimate?",
            text: "Are you sure?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Yes, Delete it!"
                }).then((result) => {
                    if (result.value) {
                        window.billing.put('estimate/delete/' + idest,{
                                user_id : window.localuserdata
                        }).then((response) => {
                                console.log(response.data);
                                this.isLoading = false;
                                    if(response.data.status){
                                        this.getEstimates();
                                         this.$notify({
                                          group: 'noti',
                                          title: 'Deleted!',
                                          type: 'success',
                                          text: 'Deleted Estimate Successful',
                                        });   
                                
                                    }
                                }).catch((error) => console.log(error,this.isLoading = false));
                    }
                });
      this.isLoading = false   
     },
     actionVoid(idest){
         this.isLoading = true 
     this.$swal({
            title: "Void this Estimate?",
            text: "You will not be able to recover it",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Yes, Void it!"
                }).then((result) => {
                    if (result.value) {
                        window.billing.put('estimate/void/' + idest,{
                                user_id : window.localuserdata
                        }).then((response) => {
                                console.log(response.data);
                                this.isLoading = false;
                                    if(response.data.status){
                                        this.getEstimates();
                                        this.$notify({
                                          group: 'noti',
                                          title: 'Void!',
                                          type: 'success',
                                          text: 'Void Estimate Successful',
                                        }); 
                                   
                                    }
                                }).catch((error) => console.log(error,this.isLoading = false));
                    }
         });
         this.isLoading = false 
     },
     actionDuplicate(id){
      this.$router.push({name:'EstimatesDuplicate', params:{idest:id, duplicate: 'duplicate'}});
     },
     convertToInvoice(id){
        this.$router.push({name:'EstimatesConvertInvoice', params:{idest:id, convert: 'convert'}});
     },
    },
    watch:{
        SettingBox: function (){
            if(!this.SettingBox ==''){
             this.$modal.show('hello-world');
            }
        }
    },
    computed :{
        Pending:  function () {
            return this.EstimatesList.filter(r => r.status === 1);
            //return this.requests.filter(r => r.status === "APPROVED");
        },
        Accepted:  function () {
            return this.EstimatesList.filter(r => r.status === 2);
        },
        Rejected:  function () {
            return this.EstimatesList.filter(r => r.status === 3);
        },
        Void:  function () {
            return this.EstimatesList.filter(r => r.status === 4);
        },
        datecreate : function (date) {
           return 'hola'
        },
        isDisabledCheck: function(){
        //return !this.FormSendMail.EmailCheck; 
       },

    }
};
</script>
<style lang="scss" scoped>
@media(max-width: 991px){
  .contenedor-estimate{
    width: 100%;
    overflow-x: scroll;
  }
}
.contenedor-estimate table{
  width: 100%;
  min-width: 767px;
  margin-bottom: 250px;
}
.contenedor-estimate table thead tr th:nth-child(1){
  min-width: 60px;
}
.contenedor-estimate table thead tr th:nth-child(2){
  min-width: 120px;
}
.contenedor-estimate table thead tr th:nth-child(3),
.contenedor-estimate table thead tr th:nth-child(4)
{
  min-width: 150px;
}
.contenedor-estimate table thead tr th{font-weight: bold;}
.paginacion{width: 70px;}
.cdropdown ul li{padding: 3px 10px;}
.cdropdown ul li button{font-size: 0.760rem;}
</style>
